import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'

import {
  Container,
  Button,
  Progress,
  Modal,
  ModalBody,
  ModalHeader
} from 'reactstrap'
import {SearchBarEmployee} from '../search-bar'
import find from 'lodash/find'
import CustomTableEmployeeCheckbox from '../../../components/table-employee-checkbox'
import * as CONSTANTS from '../../employee/constants'
import {
  consentAction,
  consentLogAction,
  modalAction,
} from '../../../actions'
import {
  consentLogSelector,
} from '../../../selectors'
//const header = [{ label: 'Name', value: 0 }, { label: 'LOB', value: 1 }, { label: 'Type', value: 2 }]
class EmployeeListConsent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: '1',
      employeeList: [],
      searchEmployee: '',
      rowID: '',
      selectedType: '',
      selectedLOB: '',
      employeeCheck: [],
      submitSent: false,
      selectAll: false,
      unSelectAll: false,
      employee_id:[],
      count: 0,
      openCollapse: false,
    }
    this.handleSearch = this.handleSearch.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  state={
    sort_order: true,
    sort_column: 0,
    users: [],
    items: [],
  }

  handleSearch = (e) => {
    this.setState({
      searchEmployee: e,
      rowID: '',
    })
  }
  filterEmployee = () => {
    const search = this.state.searchEmployee.toLowerCase()
    
    let users = this.props.data.filter((user) => { return !user.is_init_user })
    if (search !== '') {
      users = users.filter((user) => {
        return user.emp_code.toLowerCase().includes(search)
        || user.first_name.toLowerCase().includes(search)
        || user.last_name.toLowerCase().includes(search)
        || user.nick_name.toLowerCase().includes(search)
      })
    }
    const search_type = this.state.selectedType.toLowerCase()
    if(search_type !== ''){
      users = users.filter((user) => {
        return user.employee_type && user.employee_type.toLowerCase().includes(search_type)
      })
    }
    const search_lob = this.state.selectedLOB.toLowerCase()
    if(search_lob !== ''){
      users = users.filter((user) => {
        return user.lob_id && user.lob_id.toLowerCase().includes(search_lob)
      })
    }
    return users
  }
  handleInputType = (type, data) => {
    if (data.target.value !== '') {
      const leave_type = find(CONSTANTS.employee, (e) =>
        e === data.target.value
      )
      this.setState({ selectedType: leave_type })
    } else {
      this.setState({ selectedType: '' })
    }
    this.filterEmployee()
  }
  handleInputLOB = (type, data) => {
    
    if (data.target.value !== '') {
      const lob = find(this.props.masterData.masterData.lobs, {
        name : data.target.value
      }
      )
      this.setState({ selectedLOB: lob._id })
    } else {
      this.setState({ selectedLOB: '' })
    }
    this.filterEmployee()
  }
  sendEmployee = async () => {
    // const emp_list = this.state.employeeCheck.filter(name => name !== '')
    this.setState({ openCollapse: true })
    const emp_list = this.state.employee_id.filter(name => name !== '')
    await this.props.deactivateConsentLog(this.props.consentData,  localStorage.getItem('access_token'))
    for(let i = 0; i < emp_list.length; i++){
        await this.props.createLogConsent(
          {
            emp_code: emp_list[i],
            document_code: this.props.consentData,
            version: '1',
            status: 'PENDING'
          },
          localStorage.getItem('access_token'))
          const c = this.state.count;
          this.setState({count: c+1})
    }
    this.props.listCompany(localStorage.getItem('access_token'))
    this.props.listConsentLog(localStorage.getItem('access_token'))
    this.props.closeBtn()
    this.props.showConfirm('confirmSave', 'Saved Successfully', 'Your consent information had been saved.')
  }
  handleInputChange(event, code) {
    const check = this.state.employee_id
    const idx = check.indexOf(event.target.value)
    if (event.target.checked === true){
      check.push(code)
      this.setState({ employee_id: check})
    } else{
      check.splice(idx, 1)
      this.setState({ employee_id: check})
    }
  }
  render() {
    return (
        <Wrapper>
        <SearchBarEmployee 
          data={ this.state.employeeList }
          handleSearch={ this.handleSearch }
          lobs={ this.props.masterData.masterData.lobs }
          selectedType={ this.props.selectedType }
          handleInputType={ this.handleInputType }
          selectedLOB={ this.props.selectedLOB }
          handleInputLOB={ this.handleInputLOB }
          handleClickAll={ () => {
            const array_user_id = []
            const employeeCheck = this.props.data
            employeeCheck.forEach(r => { array_user_id.push(r._id) })
            this.setState({ employee_id: array_user_id })
          } }
          handleClickNone={ () => this.setState({ employee_id: [] }) }
          >
        </SearchBarEmployee>
        <CustomTableEmployeeCheckbox
              rowID={ this.state.rowID }
              users={ this.filterEmployee() }
              clickRow={ this.clickRow }
              masterData={ this.props.masterData.masterData }
              employeeCheck={ this.state.employeeCheck }
              submitSent={this.state.submitSent }
              employee_id={ this.state.employee_id}
              handleInputChange= { this.handleInputChange }
            />
        <Right>
        <Modal isOpen={ this.state.openCollapse === true} size='lg'>
        <ModalHeader>Loading...</ModalHeader>
          <ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto', 'b, strong' : 'font-weight: bold !important'}}>
          <Progress striped  value={this.state.count} max={this.state.employee_id.length} />
          </ModalBody>
        </Modal>
            <Button color="success" onClick= { () => this.sendEmployee()}>Send</Button>
            {/* <Button color="secondary" onClick= { () => this.closeConsentModal() }>Cancel</Button> */}
        </Right>
      </Wrapper>
    )
  }
}

EmployeeListConsent.propTypes = {
  handleInput: PropTypes.func.isRequired,
  cancelForm: PropTypes.func.isRequired,
  showDiscard: PropTypes.func.isRequired,
  handleModelChange: PropTypes.func.isRequired,
  createLogConsent: PropTypes.func.isRequired,
  deactivateConsentLog: PropTypes.func.isRequired,
  closeBtn: PropTypes.func.isRequired,
  listCompany: PropTypes.func.isRequired,
  listConsentLog:  PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  consentLogCreate: consentLogSelector.getCreateConsentLog,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  createLogConsent: consentLogAction.createConsentLog,
  deactivateConsentLog: consentLogAction.deactivateConsentLog,
  listCompany: consentAction.getConsentList,
  listConsentLog: consentLogAction.getConsentLog,
  showConfirm: modalAction.showConfirm,
}, dispatch)
export default connect(mapStateToProps,mapDispatchToProps)(EmployeeListConsent)
const Wrapper = styled(Container)`
  padding: 0px;
  background-color: #F1F1F1;
`
const Right = styled.div`
  background-color: white;
  padding: 10px;
  text-align: right;
`


// WEBPACK FOOTER //
// ./src/components/consent-management/employee-table/employee.js